export default __webpack_public_path__ + "static/media/hbs-k-banner-3.cfc6640e.jpg";